<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="m-3">
            <h3>Edit Service</h3>
            <div v-if="pageLoading" class="mt-3">
                Loading...
            </div>
            <EditElement :elementIdProp="pageId" category_id="2"></EditElement>
        </div>
    </div>
</template>

<script>
import EditElement from "@/components/ElementComponents/EditElement";

export default {
    name: 'editPage',
    components: {
        EditElement,
    },
    data() {
        return {
            itemsBread: [{
                text: 'Home',
                to: '/dashboard'
            }, {
                text: 'Services',
                to: '/services/all'
            }, {
                text: 'Edit Service',
                to: '/service/:id'
            },],
            pageId: null,
        };
    },
    created() {
        this.pageId = this.$route.params.id;
    },
}
</script>